import { memo, useRef } from 'react'
import KibTag from '@chewy/kib-tag-react'

import { type ColorVariant, ColorVariantToTheme } from '~/constants/colors'
import useDiagnosisStatus from '~/hooks/useDiagnosisStatus'
import type { DiagnosisSnapshotItem, MasterProblemsSnapshotItem } from '~/types'

import '@chewy/kib-tooltip-styles/dist/kib-tooltip.css'
import '@chewy/kib-tag-styles/dist/kib-tag.css'
import styles from './ProblemsStatusCell.module.scss'

interface ProblemsStatusCellProps {
  clientId: string
  item: MasterProblemsSnapshotItem | DiagnosisSnapshotItem
  patientId: string
  shorten?: boolean
}

const hasChildren = (
  item: MasterProblemsSnapshotItem | DiagnosisSnapshotItem,
): item is MasterProblemsSnapshotItem =>
  'children' in item && Array.isArray(item.children)

const ProblemsStatusCell = ({
  item,
  clientId,
  patientId,
  shorten,
}: ProblemsStatusCellProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null)
  const { activeStatus, statusDisplayName } = useDiagnosisStatus({
    item,
    shorten,
  })

  const stateName = statusDisplayName
  return (
    <div className={styles.container}>
      <div className={styles.stateNameContainer}>
        <KibTag
          theme={
            ColorVariantToTheme[activeStatus?.colorVariant as ColorVariant]
          }
        >
          <span className={styles.stateName} title={stateName}>
            {stateName}
          </span>
        </KibTag>
      </div>
    </div>
  )
}

export default memo(ProblemsStatusCell)
